// services/eventService.js
import apiClient from './apiClient';

const API_CATPASS_URL = import.meta.env.VITE_API_CATPASS_URL;

const normalizeEvent = (event, source) => {
    const identifier = event.id ?? event.slug ?? `${event.nombre || "evento"}-${event.fecha || "sin-fecha"}`;
    const isCatpass = source === "catpass";

    return {
        ...event,
        source,
        uniqueId: `${source}-${identifier}`,
        eventUrl: isCatpass
            ? `https://catpass.net/eventos/${event.slug}`
            : `/eventos/${event.slug}`,
    };
};

const parseEventDate = (event) => {
    if (!event?.fecha) return Number.POSITIVE_INFINITY;
    const date = new Date(event.fecha);
    return Number.isNaN(date.getTime()) ? Number.POSITIVE_INFINITY : date.getTime();
};

// Servicio para obtener todos los eventos
const getAllEvents = async (search = "") => {
    try {
        const params = {};

        // Solo agrega 'search' si tiene valor
        if (search.trim() !== "") {
            params.search = search.trim();
        }

        const requests = [apiClient.get("/eventos", { params })];

        if (API_CATPASS_URL) {
            requests.push(
                apiClient.get(`${API_CATPASS_URL.replace(/\/$/, "")}/eventos`, {
                    params,
                })
            );
        }

        const [passeventResult, catpassResult] = await Promise.allSettled(requests);

        const passeventEvents =
            passeventResult.status === "fulfilled"
                ? (passeventResult.value.data || []).map((event) =>
                      normalizeEvent(event, "passevent")
                  )
                : [];

        const catpassEvents =
            catpassResult?.status === "fulfilled"
                ? (catpassResult.value.data || []).map((event) =>
                      normalizeEvent(event, "catpass")
                  )
                : [];

        const events = [...passeventEvents, ...catpassEvents].sort(
            (a, b) => parseEventDate(a) - parseEventDate(b)
        );

        if (events.length > 0) {
            return events;
        }

        const passeventError =
            passeventResult.status === "rejected" ? passeventResult.reason : null;
        const catpassError =
            catpassResult?.status === "rejected" ? catpassResult.reason : null;

        if (passeventError || catpassError) {
            throw passeventError || catpassError;
        }

        return [];
    } catch (error) {
        console.error("Error al obtener los eventos:", error.message);
        throw new Error("No se pudieron cargar los eventos");
    }
};
const getEventForSlug = async (slug) => {
    try {
        const response = await apiClient.get(`/eventos/${slug}`);
        return response.data; 
    } catch (error) {
        console.error('Error al obtener los eventos:', error);
        throw error;
    }
};

export default {
    getAllEvents,
    getEventForSlug
};
